import React from 'react';
import {EAutocompleteOption} from 'webapp-lib/Components';

import {AutocompleteProps} from '#/Autocomplete/types';
import casusBackend, {MinimalClient} from '@lexian/api/casus-api';
import {getContactTypeIcon} from '_/utilities/contacts.utils';

import {
  AutocompleteBase,
  paginatedLoader,
} from './AutocompleteBase/AutocompleteBase';

type ClientTypes = NonNullable<
  Parameters<
    typeof casusBackend.searchClients
  >[0]['parameters']['clientTypeFilter']
>;

type ClientAutoCompleteProps = AutocompleteProps & {
  clientType?: ClientTypes;
  onClientsChange?: (
    clients: MinimalClient | MinimalClient[] | undefined
  ) => void;
};

export const ClientAutocomplete = ({
  clientType,
  onClientsChange,
  ...otherProps
}: ClientAutoCompleteProps): React.ReactElement => {
  const toOption = (client: MinimalClient): EAutocompleteOption => ({
    displayText: client.displayName,
    value: client.id,
    Icon:
      clientType === undefined
        ? getContactTypeIcon(client.contactType)
        : undefined,
  });

  return (
    <AutocompleteBase
      {...otherProps}
      loadItems={paginatedLoader({
        endpointFunction: casusBackend.searchClients,
        getPageItemFromResponse: (body) => body.clients,
        params: () => ({clientTypeFilter: clientType}),
      })}
      reloadTrigger={clientType}
      toOption={toOption}
      noOptionFiltering
      onItemChange={onClientsChange}
    />
  );
};
